import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import getPromosState from '../store/selectors/getPromos';
import Promo from '../components/Promo';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import promosReducer from '../store/reducers/promos';

initContainerData.register({
    reducers: {
        promos: promosReducer
    }
});

const PromosDataContainer = ({ type, portalTarget, trackingProps, styleName }) => {
    const promos = useSelector(getPromosState(type));

    return (
        <ErrorBoundaryWrapper componentName={'Promos Data Container'}>
            {promos?.map((promo, index) => {
                const { type } = promo;
                return (
                    <Promo type={type} styleName={styleName} trackingProps={trackingProps} portalTarget={portalTarget} {...promo} key={'promo-' + type + index}/>
                );
            })}
        </ErrorBoundaryWrapper>
    );
};

PromosDataContainer.propTypes = {
    type: PropTypes.string,
    portalTarget: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
    trackingProps: PropTypes.object,
    styleName: PropTypes.string
};

export default memo(PromosDataContainer);
